import { API } from "aws-amplify";
import { Result } from "../../interfaces/Result";

export async function sendNewCompetitionEmail(competitionName: string, competitionDate: string, competitionStatus: string, creatorName: string, creatorEmail: string, pdf: Blob) {
    try {    
        let data = "";
        const reader = new FileReader();
        reader.readAsDataURL(pdf); 
        reader.onloadend = async function() {
            const base64data = reader.result;                
            data = base64data as string;
            const queryData = {
                body: {
                    "competitionName": competitionName,
                    "competitionDate": competitionDate,
                    "competitionStatus": competitionStatus,
                    "creatorName": creatorName,
                    "creatorEmail": creatorEmail,
                    "attachment": data
                }
            };
            const path = "/emails/ael/new-competition";
            const response = await API.post("Emails", path, queryData);
            const result: Result = {isSuccess: response.success, type: "Confirmation", result: response.url, message: "Successfully sent the email."};
            return result;
        }
    } catch (error: any) {
        let result: Result = {isSuccess: false, type: "Confirmation", result: error, message: "Error occurred while trying to send the email." }
        return result;
    }
}

export async function sendApprovedCompetitionEmail(competitionName: string, competitionDate: string, competitionStatus: string, creatorEmail: string, pdf: Blob) {
    try {    
        let data = "";
        const reader = new FileReader();
        reader.readAsDataURL(pdf); 
        reader.onloadend = async function() {
            const base64data = reader.result;                
            data = base64data as string;
            const queryData = {
                body: {
                    "competitionName": competitionName,
                    "competitionDate": competitionDate,
                    "competitionStatus": competitionStatus,
                    "creatorEmail": creatorEmail,
                    "attachment": data
                }
            };
            const path = "/emails/ael/approved-competition";
            const response = await API.post("Emails", path, queryData);
            const result: Result = {isSuccess: response.success, type: "Confirmation", result: response.url, message: "Successfully sent the email."};
            return result;
        }
    } catch (error: any) {
        let result: Result = {isSuccess: false, type: "Confirmation", result: error, message: "Error occurred while trying to send the email." }
        return result;
    }
}

export async function sendStatusChangedCompetitionEmail(competitionName: string, competitionDate: string, competitionStatus: string, creatorEmail: string, pdf: Blob) {
    try {    
        let data = "";
        const reader = new FileReader();
        reader.readAsDataURL(pdf); 
        reader.onloadend = async function() {
            const base64data = reader.result;                
            data = base64data as string;
            const queryData = {
                body: {
                    "competitionName": competitionName,
                    "competitionDate": competitionDate,
                    "competitionStatus": competitionStatus,
                    "creatorEmail": creatorEmail,
                    "attachment": data
                }
            };
            const path = "/emails/ael/changed-status-competition";
            const response = await API.post("Emails", path, queryData);
            const result: Result = {isSuccess: response.success, type: "Confirmation", result: response.url, message: "Successfully sent the email."};
            return result;
        }
    } catch (error: any) {
        let result: Result = {isSuccess: false, type: "Confirmation", result: error, message: "Error occurred while trying to send the email." }
        return result;
    }
}